import { render } from "./ModalCreateUser.vue?vue&type=template&id=1c861045"
import script from "./ModalCreateUser.vue?vue&type=script&lang=js"
export * from "./ModalCreateUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\dcc\\site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__